export const NOT_TRACKED_CONTENT = '<not tracked>';
export const NESTED_COMPONENT = '<nested component>';
